import { useState } from 'react'

import withRenderModal from 'hocs/withRenderModal'

import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import Copy from 'share-ui/components/Icon/Icons/components/Copy'
import Done from 'share-ui/components/Icon/Icons/components/Check'
import TypographyPrimary from 'components/Typography/Primary'

import MainModal from 'modals/MainModal'
import IconButton from 'share-ui/components/IconButton/IconButton'
import TypographySecondary from 'components/Typography/Secondary'

type ShowApiKeyModalProps = {
    closeModal: () => void
    data: {
        token: string
    }
}

const ShowApiKeyModal = ({ closeModal, data }: ShowApiKeyModalProps) => {
    const { t } = useTranslation()
    const [isCopied, setIsCopied] = useState(false)

    return (
        <>
            <MainModal onClose={closeModal} title={''}>
                <StyledBody>
                    <StyledTextContainer>
                        <TypographyPrimary value={t('show-api-key-description')} size={'medium'} />
                    </StyledTextContainer>
                    <StyledTokenContainer>
                        <StyledTokenTypography>
                            <TypographyPrimary value={data.token} size={'medium'} />
                        </StyledTokenTypography>
                        <StyledTokenIcon>
                            <IconButton
                                onClick={() => {
                                    navigator.clipboard.writeText(data.token)
                                    setIsCopied(!isCopied)
                                }}
                                icon={() => (isCopied ? <Done /> : <Copy />)}
                                size={IconButton.sizes?.SMALL}
                                kind={IconButton.kinds?.TERTIARY}
                                ariaLabel='Copy'
                            />
                        </StyledTokenIcon>
                    </StyledTokenContainer>
                </StyledBody>
            </MainModal>
        </>
    )
}

export default withRenderModal('show-api-key-modal')(ShowApiKeyModal)

const StyledBody = styled.div`
    padding: 0 20px;
`

const StyledTextContainer = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 632px;
    height: 75px;
    margin-top: 16px;

    font-weight: 500;
`
const StyledTokenContainer = styled.div`
    font-size: 14px;
    width: 662px;
    height: 44px;
    border: ${({ theme }) => theme.body.secondaryBorder};

    border-radius: 6px;
    margin-top: 34px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    margin-bottom: 50px;
`
const StyledTokenTypography = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;

    margin-left: 15px;
    overflow-x: auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 600px;
`

const StyledTokenIcon = styled.div`
    display: flex;
    position: relative;

    path {
        fill: ${({ theme }) => theme.body.iconColor};
        stroke: transparent;
    }
`
